import { instance } from "apis/interceptor";
import { TUser } from "apis/user";
import axios from "axios";

export const loginWithMile = async (
  email: string,
  password: string,
  autoLogin: boolean
): Promise<{ success: boolean; statusCode: number; accessToken?: string; user?: TUser }> => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login/mile`, {
      email: email,
      password: password,
      autoLogin: autoLogin,
    });

    return {
      success: true,
      statusCode: 200,
      accessToken: res.data.accessToken,
      user: res.data.user,
    };
  } catch (error: any) {
    const statusCode = error.response.status;

    return {
      success: false,
      statusCode: statusCode,
    };
  }
};

export const loginWithGoogle = async (
  authorizationCode: string,
  redirectUri: string
): Promise<{ success: boolean; accessToken?: string; user?: TUser }> => {
  try {
    const res = await axios.post(`${process.env.REACT_APP_API_URL}/auth/login/google`, {
      authorizationCode: authorizationCode,
      redirectUri: redirectUri,
    });
    const { accessToken, user } = res.data;
    return { success: true, accessToken: accessToken, user: user };
  } catch (error: any) {
    return { success: false };
  }
};
